import AbsComponent from "../AbsComponent";

class RecentNextPrev extends AbsComponent{
    #prevBtn = {};
    #nextBtn = {};

    constructor(_store={}, _router={}, _el=''){
        super('class RecentNextPrev', _store, _router, _el);

        // new StickySidebar('.gd-btn-search-detail-sticky-wrap', {
        //     containerSelector: '.gd-btn-search-detail-sticky-wrap',
        //     innerWrapperSelector: '.gd-btn-search-detail-wrap',
        //     topSpacing: 300,
        //     resizeSensor: true
        // });


        let watchItemId = this.watch(this.store.getState, 'itemId', this.isEqual);
        this.store.subscribe( watchItemId( (_newVal, _oldVal, _path) => this.render(_newVal) ) );

        let watchSkillId = this.watch(this.store.getState, 'skillId', this.isEqual);
        this.store.subscribe( watchSkillId( (_newVal, _oldVal, _path) => this.render(_newVal) ) );

        this.#prevBtn = $('.gd-btn-search-detail-sticky-wrap .gd-btn-search-detail.gd-btn-prev');
        this.#nextBtn = $('.gd-btn-search-detail-sticky-wrap .gd-btn-search-detail.gd-btn-next');

        this.render(this.store.getState().itemId || this.store.getState().skillId);
        this.addEvents();
    }

    addEvents(){
        this.#prevBtn.on('click', (e)=>{
            this.router.goSingleParam( $(e.currentTarget).data('db'), $(e.currentTarget).data('id') );
            return false;
        });
        this.#nextBtn.on('click', (e)=>{
            this.router.goSingleParam( $(e.currentTarget).data('db'), $(e.currentTarget).data('id') );
            return false;
        });
    }

    render(_newVal){
        if( _newVal == '' ) return;
        let nowIdx = null;
        this.store.getState().recentlyViewList.map((it, idx)=>{
            if(it.id == _newVal) nowIdx = idx;
        })
        this.setBtn( this.store.getState().recentlyViewList[nowIdx+1], this.#prevBtn);
        this.setBtn( this.store.getState().recentlyViewList[nowIdx-1], this.#nextBtn);
    }

    setBtn(_obj, _btn){
        if(_obj){
            _btn.data('id', _obj.id);
            _btn.data('db', _obj.db);
            _btn.find('img').attr('src', _obj.image);

            _btn.show();
        }else{
            _btn.hide();
        }
    }



} // end of class
export default RecentNextPrev;
